import { instance } from "api/apiBase";

const getMentionTooltip = ({
  propertyName,
  disabled
}: {
  propertyName?: string;
  disabled?: boolean;
}) => {
  if (disabled && propertyName)
    return `This user does not have access to ${propertyName}. Contact your admin to update their permissions`;

  return undefined;
};

export const fetchMentions = async ({
  query,
  applicationId,
  propertyName
}: {
  query: string;
  applicationId?: string;
  propertyName?: string;
}) => {
  const user = await instance
    .get("portal/v1/users", {
      params: {
        search: query,
        application_id: applicationId
      }
    })
    .then((res) => res.data);

  const mentionItems = user.items.map((user) => {
    const disabled =
      typeof user?.can_view_application === "boolean" &&
      !user?.can_view_application;
    const tooltip = getMentionTooltip({ propertyName, disabled });

    return {
      disabled,
      tooltip,
      entity_identifier: user.id,
      entity_name: "partner_user",
      title: user.name,
      id: String(user.id)
    };
  });

  const suggestionSections = [
    {
      key: "user",
      title: "users",
      items: mentionItems
    }
  ];

  return suggestionSections;
};
